<template>
  <div
    class="header"
    style="width: 100%; z-index: 100"
    :class="{ sticky: scrollPosition > 100 }"
  >
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-layout column>
            <v-flex
              class="rect-x1 logo-container d-flex justify-space-between"
              :class="{ onScrollRect: scrollPosition > 100 }"
            >
              <router-link
                :to="{ name: 'Homepage' }"
                title="Strona główna"
                class=""
                style="max-width: 50%"
              >
                <img
                  src="/static/images/LOGO_STJ_2026.png?v=1"
                  alt=""
                  class="logo"
                  :class="{ onScrollImg: scrollPosition > 100 }"
                />
              </router-link>
              <a href="#" class="d-flex justify-space-between px-4">
                <img
                  src="/static/images/pto-compasspr.png"
                  alt=""
                  class="pto-n4d"
                  :class="{ onScrollImg: scrollPosition > 100 }"
                />
              </a>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex
          xs12
          md6
          class="rect-x1 patient-zone d-flex align-center"
          :class="{ onScrollRect: scrollPosition > 100 }"
        >
          <span :class="{ onScrollTxt: scrollPosition > 100 }"
            >strefa <br />dla pacjenta</span
          >
          <div
            style="z-index: 12"
            class="patient-menu"
            @click="$store.commit('TOGGLE_PATIENT_MENU')"
          >
            <div>MENU</div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scrollPosition: 0
    };
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  }
};
</script>

<style scoped lang="stylus">
.onScrollImg {
  max-width: 100px !important;
}
.onScrollTxt {
  font-size: 30px !important;
}
.onScrollRect {
  height: 100px !important;
}
.patient-zone{
  background-color: rgba(39, 82, 113, .9);
  position: relative;
  &:before{
    content: '';
    position: absolute;
    left: 100%;
    top: 0;
    background-color : inherit;
    height: 100%;
    width: 100%;
  }
  span{
    color: #fff;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 30px;
    line-height: 1;
    @media only screen and (min-width: 960px){
      font-size: 46px;
    }
  }
}


.header{
  position: fixed;
  z-index: 10;
}
.header.sticky{
  top: -100px;
  @media only screen and (min-width: 960px){
    top: 0px;
  }
}

.patient-menu{
  text-align: right
  width: 70px;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  right: 1rem;
  color: #fff;
  font-size: 16px;
  padding-bottom: 8px;
  @media only screen and (min-width: 960px){
    width: 115px;
    right: 0;
    padding-bottom: 16px;
  }
  &:after{
    content: '';
    position: absolute;
    bottom : 0;
    right: 0;
    width: 70px;
    background-color: #fff;
    height: 4px;
    @media only screen and (min-width: 960px){
      width: 115px;
      height: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/PatientHeader.vue